import React, { useState, useContext, useEffect } from 'react';
import Autocomplete from './AutocompleteAddress.jsx';
import LabeledInput from './LabeledInput.jsx';
import functions from '../utils/functions.js';
import { s } from '../Style.jsx';
import requests from '../utils/requests.js';
import { PersonContext } from '../providers/Person.jsx';

const DeliveryDetails = ({ order, setOrders, setViewingOrder }) => {

    const { auth } = useContext(PersonContext);

    const [showDelivery, setShowDelivery] = useState(false);

    const [loading, setLoading] = useState(false);

    const [pickup, setPickup] = useState(order?.pickup || order.vendorName);
    const [address, setAddress] = useState(order.address);
    const [date, setDate] = useState(order.date?.split('T')[0]);
    const [timeFrom, setTimeFrom] = useState(order.timeFrom);
    const [timeTo, setTimeTo] = useState(order.timeTo);
    const [customerPhone, setCustomerPhone] = useState(order.customerPhone);
    
    useEffect(() => {
        setPickup(order?.pickup || order.vendorName);
        setAddress(order.address);
        setDate(order.date?.split('T')[0]);
        setTimeFrom(order.timeFrom);
        setTimeTo(order.timeTo);
        setCustomerPhone(order.customerPhone);
    }, [showDelivery]);

    return <>
        <div style={s.row}>
            <h3 style={{ marginBottom: 10 }}>Delivery Details</h3>
            <button style={s.button} onClick={() => setShowDelivery(!showDelivery)}>{showDelivery ? "Cancel" : "Edit"}</button>
        </div>
        <div style={s.box}>

            {loading && <p style={{ ...s.rowCenter, justifyContent: "center" }}><i className="fas fa-spinner fa-spin"></i></p>}

            {showDelivery && !loading && <><div style={s.table}>
                <div style={s.cell(1)}>
                    <LabeledInput label="Customer Phone" type="phone" boxstyle={s.row} inputstyle={{ width: 160 }} value={customerPhone} onChange={setCustomerPhone} />
                </div>
                <div style={s.cell(0)}>
                    <label style={{ flex: .5 }}>Pickup Address</label>
                    <Autocomplete inputStyle={{ padding: "2px 4px", width: "100%" }} style={{ marginBottom: 0, flex: 1 }} value={pickup} onChange={setPickup} />
                </div>
                <div style={s.cell(1)}>
                    <label style={{ flex: .5 }}>Delivery Address</label>
                    <Autocomplete inputStyle={{ padding: "2px 4px", width: "100%" }} style={{ marginBottom: 0, flex: 1 }} value={address} onChange={setAddress} />
                </div>
                <div style={s.cell(0)}>
                    <LabeledInput label="Date" type="date" boxstyle={s.row} inputstyle={{ width: 140 }} value={date} onChange={setDate} />
                </div>
                <div style={s.cell(1)}>
                    <LabeledInput label="From" type="time" boxstyle={s.row} inputstyle={{ width: 140 }} value={timeFrom} onChange={setTimeFrom} />
                    <LabeledInput label="To" type="time" boxstyle={s.row} inputstyle={{ width: 140 }} value={timeTo} onChange={setTimeTo} />
                </div>
            </div>
                <button onClick={() => {
                    setShowDelivery(false);
                    requests.updateOrder({
                        auth,
                        setLoading,
                        id: order.id,
                        values: { pickup, address, date, timeFrom, timeTo, customerPhone }
                    }).then(() => {
                        setViewingOrder({ ...order, pickup, address, date, timeFrom, timeTo, customerPhone });
                        setOrders(orders => orders.map(o => o.id === order.id ? { ...o, pickup, address, date, timeFrom, timeTo, customerPhone } : o));
                        setLoading(false);
                    });
                }}>Save</button>
            </>}

            {!showDelivery && !loading && <div style={{ ...s.table, marginBottom: 0 }}>
                <div style={s.cell(1)}>
                    <span style={{ fontSize: 14 }}>Customer Phone</span>
                    <span style={{ fontSize: 14 }}>{order.customerPhone}</span>
                </div>
                <div style={s.cell(0)}>
                    <span style={{ fontSize: 14 }}>Pickup Address</span>
                    <span style={{ fontSize: 14 }}>{order?.pickup?.split(',')[0] || order.vendorName}</span>
                </div>
                <div style={s.cell(1)}>
                    <span style={{ fontSize: 14 }}>Delivery Address</span>
                    <span style={{ fontSize: 14 }}>{order?.address?.split(',')[0]}</span>
                </div>
                <div style={s.cell(0)}>
                    <span style={{ fontSize: 14 }}>Date</span>
                    <span style={{ fontSize: 14 }}>{functions.formatMonth[parseInt(order?.date?.split('T')[0].split('-')[1]) - 1]} {parseInt(order?.date?.split('T')[0].split('-')[2])}</span>
                </div>
                <div style={s.cell(1)}>
                    <span style={{ fontSize: 14 }}>Window</span>
                    <span style={{ fontSize: 14 }}>{functions.formatTwelveHour(order.timeFrom, ' - ')}{functions.formatTwelveHour(order.timeTo)}</span>
                </div>
            </div>}
        </div>
    </>;
}

export default DeliveryDetails;